'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resourcesUpdateSucceeded = resourcesUpdateSucceeded;
exports.resourcesUpdateFailed = resourcesUpdateFailed;
var RESOURCES_UPDATE_REQUESTED = exports.RESOURCES_UPDATE_REQUESTED = 'RESOURCES_UPDATE_REQUESTED';

// An action creator is not required for RESOURCES_UPDATE_REQUESTED, we simply use the
//  RESOURCES_UPDATE_REQUESTED action type as the 'submitAction' in onSubmitActions.
//  (see actions/reduxFormSubmitActions.js for more information)


var RESOURCES_UPDATE_SUCCEEDED = exports.RESOURCES_UPDATE_SUCCEEDED = 'RESOURCES_UPDATE_SUCCEEDED';

function resourcesUpdateSucceeded() {
    return {
        type: RESOURCES_UPDATE_SUCCEEDED
    };
}

var RESOURCES_UPDATE_FAILED = exports.RESOURCES_UPDATE_FAILED = 'RESOURCES_UPDATE_FAILED';

function resourcesUpdateFailed(errors) {
    return {
        type: RESOURCES_UPDATE_FAILED,
        errors: errors
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/resourcesActions.js
// module id = 303
// module chunks = 0